import React, { useEffect, useState, useCallback } from "react";
import Button from "./Button";

const ResendOtpButton = ({
  onResend,
  isPanding,
  otpData,
  autoCountDown = true,
}) => {
  const COUNTDOWN_SECONDS = 300; // 5 minutes
  const [secondsLeft, setSecondsLeft] = useState(0);

  const formatTime = (sec) => {
    const min = Math.floor(sec / 60);
    const remSec = sec % 60;
    return `${String(min).padStart(2, "0")}:${String(remSec).padStart(2, "0")}`;
  };

  const startCountdown = useCallback(() => {
    if (autoCountDown) setSecondsLeft(COUNTDOWN_SECONDS);
  }, [autoCountDown]);

  useEffect(() => {
    if (!autoCountDown || secondsLeft <= 0) return;

    const interval = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [secondsLeft, autoCountDown]);

  useEffect(() => {
    // Start countdown when a successful OTP resend is detected
    if (autoCountDown || (otpData?.status >= 200 && otpData?.status < 300)) {
      startCountdown();
    }
  }, [otpData, autoCountDown, startCountdown]);

  const handleResend = () => {
    onResend?.(); // Trigger resend, countdown is handled in effect
  };

  const isDisabled = autoCountDown ? secondsLeft > 0 : false;

  return (
    <Button
      buttonLabel={
        autoCountDown && isDisabled
          ? `Resend in ${formatTime(secondsLeft)}`
          : "Resend OTP"
      }
      isDisable={isDisabled}
      buttonType="button"
      buttonFunction={handleResend}
      loading={isPanding}
      buttonClasses={`px-4 py-2 rounded text-white transition ${
        isDisabled
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-blue-600 hover:bg-blue-700"
      }`}
    />
  );
};

export default ResendOtpButton;
